import config from "@/config"
import http from "@/utils/request"

export default {
	menu: {
		myMenus: {
			url: `${config.API_URL}/system/menu/my/1.6.1`,
			name: "获取我的菜单",
			get: async function(){
				return await http.get(this.url);
			}
		},
		list: {
			url: `${config.API_URL}/system/menu/list`,
			name: "获取菜单",
			get: async function(){
				return await http.get(this.url);
			}
		}
	},
	dic: {
		tree: {
			url: `${config.API_URL}/system/dic/tree`,
			name: "获取字典树",
			get: async function(){
				return await http.get(this.url);
			}
		},
		list: {
			url: `${config.API_URL}/system/dic/list`,
			name: "字典明细",
			get: async function(params){
				return await http.get(this.url, params);
			}
		},
		get: {
			url: `${config.API_URL}/system/dic/get`,
			name: "获取字典数据",
			get: async function(params){
				return await http.get(this.url, params);
			}
		}
	},
	role: {
		list: {
			url: `${config.API_URL}/system/role/list2`,
			name: "获取角色列表",
			get: async function(params){
				return await http.get(this.url, params);
			}
		}
	},
	dept: {
		list: {
			url: `${config.API_URL}/system/dept/list`,
			name: "获取部门列表",
			get: async function(params){
				return await http.get(this.url, params);
			}
		}
	},
	user: {
		list: {
			url: `${config.API_URL}/system/user/list`,
			name: "获取用户列表",
			get: async function(params){
				return await http.get(this.url, params);
			}
		}
	},
	app: {
		list: {
			url: `${config.API_URL}/system/app/list`,
			name: "应用列表",
			get: async function(){
				return await http.get(this.url);
			}
		}
	},
	log: {
		list: {
			url: `${config.API_URL}/system/log/list`,
			name: "日志列表",
			get: async function(params){
				return await http.get(this.url, params);
			}
		}
	},
	table: {
		list: {
			url: `${config.API_URL}/system/table/list`,
			name: "表格列管理列表",
			get: async function(params){
				return await http.get(this.url, params);
			}
		},
		info: {
			url: `${config.API_URL}/system/table/info`,
			name: "表格列管理详情",
			get: async function(params){
				return await http.get(this.url, params);
			}
		}
	},
	tasks: {
		list: {
			url: `${config.API_URL}/system/tasks/list`,
			name: "系统任务管理",
			get: async function(params){
				return await http.get(this.url, params);
			}
		}
	},
	// 存储设置（/manage/storage/*，对应后端 manage.Storage 控制器，mn_sys_config storage 组）
	storage: {
		// 基础设置：GET ?type=storage&name=base -> {upload_allow_ext, upload_allow_size}；POST 保存
		base: {
			url: `${config.API_URL}/manage/storage/base`,
			name: "存储基础设置",
			get: async function(params){
				return await http.get(this.url, params);
			},
			post: async function(data){
				return await http.post(this.url, data);
			}
		},
		// 存储引擎列表（local/qnoss/alioss 卡片：name/path/engine/status）
		lists: {
			url: `${config.API_URL}/manage/storage/lists`,
			name: "存储引擎列表",
			get: async function(){
				return await http.get(this.url);
			}
		},
		// 引擎配置详情：GET ?engine=local|qnoss|alioss
		detail: {
			url: `${config.API_URL}/manage/storage/detail`,
			name: "存储配置详情",
			get: async function(params){
				return await http.get(this.url, params);
			}
		},
		// 保存引擎配置（engine/status + 各引擎参数）
		setup: {
			url: `${config.API_URL}/manage/storage/setup`,
			name: "保存存储配置",
			post: async function(data){
				return await http.post(this.url, data);
			}
		}
	},
	// 阿里云短信配置（/manage/sms/base，对应后端 manage.Sms 控制器，mn_sys_config sms 组）
	sms: {
		// 短信配置：GET -> {aliyun_AccessKeyId, aliyun_AccessKeySecret, aliyun_SignName, aliyun_sms_template_code, verify_expire_time, sms_limit, sms_debug}；POST 保存
		base: {
			url: `${config.API_URL}/manage/sms/base`,
			name: "阿里云短信配置",
			get: async function(){
				return await http.get(this.url);
			},
			post: async function(data){
				return await http.post(this.url, data);
			}
		}
	}
}
